/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * What the mapping matches.
 */
export const SetDirectoryRoleMappingsFormSourceKind = {
  Group: "group",
  Attribute: "attribute",
} as const;
/**
 * What the mapping matches.
 */
export type SetDirectoryRoleMappingsFormSourceKind = ClosedEnum<
  typeof SetDirectoryRoleMappingsFormSourceKind
>;

export type SetDirectoryRoleMappingsForm = {
  /**
   * Attribute key to match. Required when source_kind is attribute.
   */
  attributeKey?: string | undefined;
  /**
   * Attribute value to match. Required when source_kind is attribute.
   */
  attributeValue?: string | undefined;
  /**
   * Directory group to map. Required when source_kind is group.
   */
  directoryGroupId?: string | undefined;
  /**
   * Optional compare-and-set precondition. The normalized current role set must match or the request returns conflict without changes. Omit for unconditional replacement; an empty array requires an unmapped source.
   */
  expectedRoleUrns?: Array<string> | undefined;
  /**
   * The complete set of role principal URNs to grant, from Role.principal_urn. Empty removes every mapping for the source.
   */
  roleUrns: Array<string>;
  /**
   * What the mapping matches.
   */
  sourceKind: SetDirectoryRoleMappingsFormSourceKind;
};

/** @internal */
export const SetDirectoryRoleMappingsFormSourceKind$outboundSchema:
  z.ZodMiniEnum<typeof SetDirectoryRoleMappingsFormSourceKind> = z.enum(
    SetDirectoryRoleMappingsFormSourceKind,
  );

/** @internal */
export type SetDirectoryRoleMappingsForm$Outbound = {
  attribute_key?: string | undefined;
  attribute_value?: string | undefined;
  directory_group_id?: string | undefined;
  expected_role_urns?: Array<string> | undefined;
  role_urns: Array<string>;
  source_kind: string;
};

/** @internal */
export const SetDirectoryRoleMappingsForm$outboundSchema: z.ZodMiniType<
  SetDirectoryRoleMappingsForm$Outbound,
  SetDirectoryRoleMappingsForm
> = z.pipe(
  z.object({
    attributeKey: z.optional(z.string()),
    attributeValue: z.optional(z.string()),
    directoryGroupId: z.optional(z.string()),
    expectedRoleUrns: z.optional(z.array(z.string())),
    roleUrns: z.array(z.string()),
    sourceKind: SetDirectoryRoleMappingsFormSourceKind$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      attributeKey: "attribute_key",
      attributeValue: "attribute_value",
      directoryGroupId: "directory_group_id",
      expectedRoleUrns: "expected_role_urns",
      roleUrns: "role_urns",
      sourceKind: "source_kind",
    });
  }),
);

export function setDirectoryRoleMappingsFormToJSON(
  setDirectoryRoleMappingsForm: SetDirectoryRoleMappingsForm,
): string {
  return JSON.stringify(
    SetDirectoryRoleMappingsForm$outboundSchema.parse(
      setDirectoryRoleMappingsForm,
    ),
  );
}
